import React from 'react';
import PropTypes from 'prop-types';
import { WithLeaseShare } from 'site-modules/lease-deals/components/with-lease-share/with-lease-share';
import { Image } from 'site-modules/shared/components/image/image';
import { SOURCES } from 'client/utils/image-helpers';

import './share-button.scss';

export const ShareButton = ({ year, make, model, id, styleId }) => {
  return (
    <span className="share-wrapper pos-a">
      <WithLeaseShare year={year} make={make} model={model} id={id} styleId={styleId} shareSource="details">
        {({ onShare, isSupported, title, imageSrc }) => (
          <button
            className="lease-deals-details-modal-share-button pos-r rounded-circle d-inline-flex justify-content-center align-items-center"
            onClick={onShare}
            aria-label="Share this deal"
            disabled={!isSupported}
            title={title}
          >
            <Image imageId={imageSrc} source={SOURCES.STATIC} width={20} height={20} ariaHidden lazy />
          </button>
        )}
      </WithLeaseShare>
    </span>
  );
};

ShareButton.propTypes = {
  styleId: PropTypes.number.isRequired,
  id: PropTypes.string.isRequired,
  make: PropTypes.string.isRequired,
  model: PropTypes.string.isRequired,
  year: PropTypes.number.isRequired,
};
